import { useCallback } from 'react';
import type { PixelateValue } from '../../lib/filters/pixelate';
import type { AdjustmentPanelProps } from '../adjustments/registry';
import { RangeRow } from '../adjustments/RangeRow';

/** Pixelate panel — single block-size slider. */
export function PixelatePanel({ value, onChange }: AdjustmentPanelProps<PixelateValue>) {
  const set = useCallback(
    (patch: Partial<PixelateValue>) => onChange({ ...value, ...patch }),
    [onChange, value],
  );
  return (
    <div className="space-y-3">
      <RangeRow
        label="Block Size"
        min={1}
        max={50}
        step={1}
        value={value.blockSize}
        onChange={(v) => set({ blockSize: v })}
      />
    </div>
  );
}
